
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"39","viewBox":"0 0 40 39","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.9 14.644H18.388a3.231 3.231 0 00-3.226 3.237V32.45a3.231 3.231 0 003.225 3.237H32.9a3.231 3.231 0 003.225-3.237V17.881a3.231 3.231 0 00-3.225-3.237z","stroke":"#B3B3B3","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.713 24.356H7.1a3.219 3.219 0 01-2.28-.948 3.244 3.244 0 01-.945-2.29V6.55c0-.859.34-1.682.945-2.29a3.219 3.219 0 012.28-.947h14.513c.855 0 1.675.34 2.28.948.605.607.944 1.43.944 2.289v1.619","stroke":"#B3B3B3","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.287 19.86v10.072m-4.935-5.036h9.869","stroke":"#B3B3B3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    